/* ============================================================
   HOUSE OF MENA — theme behaviors (Shopify)
   Header/footer/overlays are rendered by Liquid sections; this
   file only wires interactions, cart AJAX and the variant picker.
   ============================================================ */
(function () {
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const routes = (window.HOM && window.HOM.routes) || { cart_add: '/cart/add', cart_change: '/cart/change', cart: '/cart', search: '/search', root: '/' };

  /* ---------- Overlays: [data-open="mobile|search|cart"], [data-close], scrim ---------- */
  // Getters, not cached nodes: the theme editor re-renders header / drawer sections in place.
  const overlays = {
    get mobile() { return $('.mobile-nav'); },
    get search() { return $('.search-overlay'); },
    get cart() { return $('.cart-drawer'); },
  };
  const scrim = $('[data-scrim]') || $('.scrim');
  let openKey = null;
  function closeAll() {
    Object.values(overlays).forEach((o) => o && o.classList.remove('open'));
    scrim && scrim.classList.remove('show');
    document.body.style.overflow = '';
    openKey = null;
  }
  function open(key) {
    if (!overlays[key]) return;
    closeAll();
    overlays[key].classList.add('open');
    scrim && scrim.classList.add('show');
    document.body.style.overflow = 'hidden';
    openKey = key;
    if (key === 'search') setTimeout(() => { const i = $('input', overlays.search); i && i.focus(); }, 350);
  }
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open]');
    const key = o && o.dataset.open;
    if (o && (key === 'mobile' || key === 'search' || key === 'cart')) { e.preventDefault(); open(key); return; }   // any other data-open value is a section's own state, not an overlay
    if (e.target.closest('[data-close]') || e.target === scrim) closeAll();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && openKey) closeAll(); });
  window.HOM = window.HOM || {}; window.HOM.openOverlay = open; window.HOM.closeOverlays = closeAll;

  /* ---------- Desktop mega menus — hover intent ---------- */
  function initMega(li) {
    if (li.dataset.megaBound) return;
    li.dataset.megaBound = '1';
    let t;
    li.addEventListener('mouseenter', () => { clearTimeout(t); $$('.nav-bar .has-mega.open').forEach((o) => o !== li && o.classList.remove('open')); li.classList.add('open'); });
    li.addEventListener('mouseleave', () => { t = setTimeout(() => li.classList.remove('open'), 120); });
    li.addEventListener('focusin', () => li.classList.add('open'));
    li.addEventListener('focusout', (e) => { if (!li.contains(e.relatedTarget)) li.classList.remove('open'); });
  }
  $$('.nav-bar .has-mega').forEach(initMega);
  document.addEventListener('shopify:section:load', (e) => $$('.nav-bar .has-mega', e.target).forEach(initMega));

  /* ---------- Mobile submenu accordions ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.mobile-nav [data-sub]');
    if (!btn) return;
    const li = btn.parentElement;
    const was = li.classList.contains('open');
    $$('.mobile-nav li.open').forEach((x) => { x.classList.remove('open'); const s = $('[data-sub] span', x); if (s) s.textContent = '+'; });
    if (!was) { li.classList.add('open'); const s = $('span', btn); if (s) s.textContent = '−'; }
  });

  /* ---------- Scroll reveal ---------- */
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealAll = () => $$('.reveal').forEach((n) => n.classList.add('in'));
  if (reduce || !('IntersectionObserver' in window)) revealAll();
  else {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { threshold: 0.12 });
    $$('.reveal').forEach((n) => io.observe(n));
    // anything still hidden after 2.5s (e.g. inside the theme editor) is revealed
    setTimeout(revealAll, 2500);
  }
  document.addEventListener('shopify:section:load', revealAll);

  /* ---------- Hero rotation ---------- */
  function initHero(hero) {
    const slides = $$('.slide', hero);
    if (slides.length < 2) return;
    const dots = $$('.dots button', hero);
    const every = parseInt(hero.dataset.interval || '5200', 10);
    let i = slides.findIndex((s) => s.classList.contains('active')); if (i < 0) i = 0;
    const show = (n) => {
      slides[i].classList.remove('active'); dots[i] && dots[i].classList.remove('on');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('active'); dots[i] && dots[i].classList.add('on');
    };
    let timer = reduce ? null : setInterval(() => show(i + 1), every);
    dots.forEach((d, n) => d.addEventListener('click', () => { if (timer) clearInterval(timer); show(n); if (!reduce) timer = setInterval(() => show(i + 1), every); }));
  }
  $$('.hero').forEach(initHero);
  document.addEventListener('shopify:section:load', (e) => $$('.hero', e.target).forEach(initHero));

  /* ---------- Cart: AJAX add / change, drawer refresh ---------- */
  const money = (cents) => {
    const fmt = (window.HOM && window.HOM.moneyFormat) || '${{amount}}';
    const n = cents / 100;
    const amount = Number.isInteger(n) ? n.toLocaleString('en-US') : n.toFixed(2);
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  };
  window.HOM.money = money;

  function setBagCount(n) { $$('.bag-count').forEach((c) => { c.textContent = n; }); }
  // Section-group sections get generated ids (e.g. sections--123__cart_drawer); read the real one
  // from the wrapper so the Section Rendering API returns this instance with its saved settings.
  function drawerSectionId() {
    const wrap = overlays.cart && overlays.cart.closest('.shopify-section');
    return wrap && wrap.id ? wrap.id.replace(/^shopify-section-/, '') : 'cart-drawer';
  }
  function drawerHtml(sections) { return sections ? sections[drawerSectionId()] : null; }
  function replaceDrawer(html) {
    const drawer = overlays.cart;
    if (!drawer || !html) return;
    const tmp = document.createElement('div'); tmp.innerHTML = html;
    const fresh = tmp.querySelector('.cart-drawer') || tmp.firstElementChild;
    if (fresh) drawer.innerHTML = fresh.innerHTML;
  }
  async function cartRequest(url, body) {
    const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(Object.assign({ sections: drawerSectionId() }, body)) });
    const data = await res.json();
    if (!res.ok) throw data;
    return data;
  }
  async function refreshDrawer() {
    try {
      const res = await fetch(routes.root + '?sections=' + encodeURIComponent(drawerSectionId()));
      const data = await res.json();
      replaceDrawer(drawerHtml(data));
      const c = await (await fetch(routes.cart + '.js')).json();
      setBagCount(c.item_count);
    } catch (e) { /* silent */ }
  }
  window.HOM.addToCart = async function (variantId, quantity, properties) {
    const data = await cartRequest(routes.cart_add + '.js', { items: [{ id: variantId, quantity: quantity || 1, properties: properties || undefined }] });
    if (drawerHtml(data.sections)) replaceDrawer(drawerHtml(data.sections)); else await refreshDrawer();
    const c = await (await fetch(routes.cart + '.js')).json();
    setBagCount(c.item_count);
    open('cart');
    return data;
  };
  // Quick add buttons: <button data-add data-variant-id="123">
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-add][data-variant-id]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    b.disabled = true; const label = b.innerHTML; b.textContent = 'Adding…';
    try { await window.HOM.addToCart(parseInt(b.dataset.variantId, 10), 1); b.textContent = 'Added'; }
    catch (err) { b.textContent = (err && err.description) || 'Unavailable'; }
    setTimeout(() => { b.innerHTML = label; b.disabled = false; }, 1600);
  });
  // Product forms: <form data-product-form> — intercept submit
  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('form[data-product-form]');
    if (!f) return;
    e.preventDefault();
    const id = parseInt((f.querySelector('[name="id"]') || {}).value, 10);
    const qty = parseInt((f.querySelector('[name="quantity"]') || { value: 1 }).value, 10) || 1;
    const btn = f.querySelector('[type="submit"]');
    const label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    try { await window.HOM.addToCart(id, qty); }
    catch (err) { if (btn) btn.textContent = (err && err.description) || 'Unavailable'; setTimeout(() => { if (btn) { btn.innerHTML = label; btn.disabled = false; } }, 2000); return; }
    if (btn) { btn.innerHTML = label; btn.disabled = false; }
  });
  // Drawer line changes: <button data-cart-change data-line="1" data-qty="2">
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-cart-change]');
    if (!b) return;
    e.preventDefault();
    try {
      const data = await cartRequest(routes.cart_change + '.js', { line: parseInt(b.dataset.line, 10), quantity: parseInt(b.dataset.qty, 10) });
      if (drawerHtml(data.sections)) replaceDrawer(drawerHtml(data.sections));
      setBagCount(data.item_count);
      if (document.body.classList.contains('template-cart')) location.reload();
    } catch (err) { /* keep state */ }
  });

  /* ---------- Variant picker (PDP) ----------
     Markup: <div data-variant-picker data-product='{{ product | json }}'>
       option groups: <div class="sizes" data-option-index="0"><button class="size" data-value="M">M</button></div>
       or swatches: <div class="swatches" data-option-index="1"><button class="swatch" data-value="Black"></button></div>
       targets: [data-variant-id-input], [data-variant-price], [data-atb], [data-sticky-price]
  */
  function initPicker(root) {
    if (root.dataset.pickerBound) return;
    root.dataset.pickerBound = '1';
    let product; try { product = JSON.parse(root.dataset.product); } catch (e) { return; }
    const groups = $$('[data-option-index]', root);
    const selected = product.options.map((_, idx) => {
      const g = groups.find((x) => parseInt(x.dataset.optionIndex, 10) === idx);
      const on = g && ($('.on', g) || $('[data-value]', g));
      return on ? on.dataset.value : null;
    });
    const find = () => product.variants.find((v) => v.options.every((o, idx) => selected[idx] === null || o === selected[idx]));
    // Colour → photos (only on products with a colour choice; the section renders the same order on first load):
    // 0 the chosen colour's own photo · 1 other photos of that colour · 2 photos naming no colour · 3 other colours.
    const page = root.closest('.pdp-page') || document;
    const gallery = $('.pdp-gallery', page);
    const colourGroup = groups.find((g) => g.hasAttribute('data-colour-option'));
    const colourIdx = colourGroup ? parseInt(colourGroup.dataset.optionIndex, 10) : -1;
    const CAP = 7;
    const SIZES_WIDE = '(min-width: 900px) 57vw, 100vw';
    const SIZES_TILE = '(min-width: 900px) 28vw, 50vw';
    const norm = (s) => String(s === null || s === undefined ? '' : s).toLowerCase().replace(/\u200b/g, '').replace(/[\u2014\u2013\-,|\/.():@=]+/g, ' ').replace(/\s+/g, ' ').trim();
    const mediaOrder = {};
    (product.media || []).forEach((m, i) => { mediaOrder[String(m.id)] = i; });
    const tilesOf = () => (gallery ? $$('[data-media-id]', gallery) : []);
    const holdsVideo = (t) => !!t.querySelector('video, iframe');
    // returns { moved, own }: did any tile change place · does the chosen colour have photos of its own
    const arrange = (v) => {
      const none = { moved: false, own: false };
      if (!gallery || colourIdx < 0) return none;
      const tiles = tilesOf();
      if (tiles.length < 1) return none;
      const colour = norm(selected[colourIdx]);
      if (!colour) return none;
      // the exact colour + size pair may not be made — any variant of the colour still knows its photo
      const gv = v || product.variants.find((x) => norm(x.options[colourIdx]) === colour);
      const lead = gv && gv.featured_media ? String(gv.featured_media.id) : '';
      const rank = (t) => {
        if (lead && t.dataset.mediaId === lead) return 0;
        const c = norm(t.dataset.mediaColour);
        return c === '' ? 2 : (c === colour ? 1 : 3);
      };
      const place = (t) => (mediaOrder[t.dataset.mediaId] === undefined ? 999 : mediaOrder[t.dataset.mediaId]);
      // a video must not be moved (moving it restarts it): it keeps its slot and is never hidden; photos sort around it
      const own = tiles.some((t) => rank(t) < 2);
      const movable = tiles.filter((t) => !holdsVideo(t)).sort((a, b) => (rank(a) - rank(b)) || (place(a) - place(b)));
      const next = tiles.map((t) => (holdsVideo(t) ? t : movable.shift()));
      if (next.every((t, i) => t === tiles[i])) return { moved: false, own };
      next.forEach((t, i) => {
        let now = tilesOf();
        if (now[i] === t) return;
        if (holdsVideo(t)) {
          let guard = now.length;
          while (now[i] !== t && guard-- > 0) { gallery.appendChild(now[i]); now = tilesOf(); }
        } else {
          gallery.insertBefore(t, now[i]);
        }
      });
      next.forEach((t, i) => {
        const wide = next.length > 2 && i === 2;
        t.classList.toggle('wide', wide);
        t.hidden = i >= CAP && !holdsVideo(t);
        const im = t.querySelector('img');
        if (im && im.getAttribute('sizes')) im.sizes = wide ? SIZES_WIDE : SIZES_TILE;
        // a photo with no description is named by its place ("… — view 3") — keep that number in step with its new place
        if (im && t.hasAttribute('data-alt-auto')) im.alt = im.alt.replace(/\d+$/, String(i + 1));
        if (t.hasAttribute('aria-label')) t.setAttribute('aria-label', 'View photo ' + (i + 1) + (im && im.alt ? ': ' + im.alt : ''));
      });
      return { moved: true, own };
    };
    const apply = (colourChanged) => {
      const v = find();
      // The photos follow the colour only. On first load the section has already put them in order, and a size
      // (or the colour already chosen) leaves them where they are.
      const shown = colourChanged ? arrange(v) : { moved: false, own: false };
      $$('[data-option-selected]', root).forEach((el) => {
        const i = parseInt(el.dataset.optionSelected, 10);
        if (selected[i] !== null && selected[i] !== undefined) el.textContent = selected[i];
      });
      if (colourChanged) {
        const live = $('[data-colour-live]', root);
        if (live) live.textContent = shown.own ? (live.dataset.template || 'Showing photos in [colour]').replace('[colour]', selected[colourIdx]) : '';
      }
      const input = $('[data-variant-id-input]'); if (input && v) input.value = v.id;
      $$('[data-variant-price]').forEach((el) => { if (v) el.textContent = money(v.price); });
      $$('[data-sticky-price]').forEach((el) => { if (v) el.textContent = money(v.price); });
      $$('[data-atb]').forEach((btn) => {
        const ok = v && v.available;
        btn.disabled = !ok;
        const priceEl = $('[data-variant-price]', btn);
        // labels come from the section settings via data attributes; the literals are the fallback
        const soldLabel = btn.dataset.soldLabel || 'Sold out';
        const naLabel = btn.dataset.unavailableLabel || 'Unavailable';
        if (!priceEl) btn.textContent = ok ? (btn.dataset.label || 'Add to Bag') : (v ? soldLabel : naLabel);
        else btn.firstChild && (btn.firstChild.textContent = (ok ? (btn.dataset.label || 'Add to Bag') : (v ? soldLabel : naLabel)) + ' — ');
      });
      if (v && history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      // mark unavailable combos
      groups.forEach((g) => {
        const idx = parseInt(g.dataset.optionIndex, 10);
        $$('[data-value]', g).forEach((b) => {
          const test = selected.slice(); test[idx] = b.dataset.value;
          const match = product.variants.find((vv) => vv.options.every((o, i) => test[i] === null || o === test[i]));
          // a colour is off only when none of its variants can be bought; sizes still answer for the exact pair
          const off = g === colourGroup
            ? !product.variants.some((vv) => vv.options[idx] === b.dataset.value && vv.available)
            : (!match || !match.available);
          b.classList.toggle('off', off);
          if (g === colourGroup) {
            // a sold-out colour stays selectable (its photos can still be seen) — say so in words, not only in looks
            const name = b.dataset.value + (off ? ' — ' + (g.dataset.soldout || 'Sold out') : '');
            b.setAttribute('aria-label', name); b.title = name;
          }
        });
      });
      return shown;
    };
    groups.forEach((g) => g.addEventListener('click', (e) => {
      const b = e.target.closest('[data-value]'); if (!b) return;
      $$('.on', g).forEach((x) => { x.classList.remove('on'); x.setAttribute('aria-pressed', 'false'); });
      b.classList.add('on'); b.setAttribute('aria-pressed', 'true');
      const at = parseInt(g.dataset.optionIndex, 10);
      const colourChanged = g === colourGroup && selected[at] !== b.dataset.value;
      selected[at] = b.dataset.value;
      const shown = apply(colourChanged);
      // Where the photos sit above the colour dots (phones): if this colour's photos came forward and the first one is
      // off-screen, bring it back into view — never for keyboard users (e.detail is 0), whose focus must stay put.
      const stacked = gallery && root.getBoundingClientRect().top >= gallery.getBoundingClientRect().bottom - 1;
      if (shown.moved && shown.own && stacked && e.detail !== 0 && root.dataset.colourScroll !== 'off') {
        const first = tilesOf().find((t) => !t.hidden) || gallery;
        const r = first.getBoundingClientRect();
        // the header section lowers --header-h on <body> when the announcement bar is off
        const head = parseInt(getComputedStyle(document.body).getPropertyValue('--header-h'), 10) || 0;
        if (r.bottom < head + 40 || r.top > window.innerHeight) {
          const calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: Math.max(0, window.scrollY + r.top - head - 16), behavior: calm ? 'auto' : 'smooth' });
        }
      }
    }));
    apply(false);
  }
  $$('[data-variant-picker]').forEach(initPicker);
  document.addEventListener('shopify:section:load', (e) => $$('[data-variant-picker]', e.target).forEach(initPicker));

  /* ---------- Sticky add-to-bag proxies the main form ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-sticky-atb]');
    if (!b) return;
    e.preventDefault();
    const f = $('form[data-product-form]');
    if (f) f.requestSubmit ? f.requestSubmit() : f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  });

  /* ---------- Wishlist (local, per browser) ---------- */
  const WK = 'hom-wishlist';
  const wish = () => { try { return JSON.parse(localStorage.getItem(WK) || '[]'); } catch (e) { return []; } };
  const paint = () => { const w = wish(); $$('[data-wish]').forEach((b) => { const on = w.includes(b.dataset.wish); b.classList.toggle('saved', on); b.style.color = on ? 'var(--clay)' : ''; }); };
  document.addEventListener('click', (e) => {
    const s = e.target.closest('[data-wish]');
    if (!s) return;
    e.preventDefault(); e.stopPropagation();
    const w = wish(); const h = s.dataset.wish;
    const next = w.includes(h) ? w.filter((x) => x !== h) : w.concat(h);
    try { localStorage.setItem(WK, JSON.stringify(next)); } catch (err) { /* ignore */ }
    paint();
  });
  paint();

  /* ---------- Collection page: "Load more" via pagination fetch ---------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-load-more]');
    if (!b) return;
    e.preventDefault();
    const next = b.getAttribute('href'); if (!next) return;
    b.disabled = true; b.textContent = 'Loading…';
    try {
      const html = await (await fetch(next)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = $('[data-product-grid]'); const more = $('[data-product-grid]', doc);
      if (grid && more) { Array.from(more.children).forEach((c) => grid.appendChild(c)); revealAll(); }
      const nb = $('[data-load-more]', doc);
      if (nb) { b.setAttribute('href', nb.getAttribute('href')); b.disabled = false; b.textContent = b.dataset.label || 'Load more'; }
      else b.remove();
      const count = $('[data-shown-count]'); const fresh = $('[data-shown-count]', doc);
      if (count && fresh) count.textContent = fresh.textContent;
    } catch (err) { location.href = next; }
  });

  /* ---------- Collection filters: submit facets form on change ---------- */
  document.addEventListener('change', (e) => {
    const f = e.target.closest('form[data-facets-form]');
    if (f) f.requestSubmit ? f.requestSubmit() : f.submit();
  });
})();

/* ---------- Predictive search: live results under the search box ----------
   Reads the overlay's data-predictive / -limit / -labels (set by sections/header.liquid), fetches
   sections/predictive-search.liquid through Shopify's Section Rendering API after two letters,
   and swaps it in for the static suggestion columns. Esc clears the box first, then closes. */
(function () {
  function init(overlay) {
    if (!overlay || overlay.dataset.predictiveBound || overlay.dataset.predictive !== 'on') return;
    var input = overlay.querySelector('input[name="q"]');
    var live = overlay.querySelector('[data-predictive]');
    if (!input || !live || !window.fetch) return;
    overlay.dataset.predictiveBound = '1';
    var stat = overlay.querySelector('.search-suggest:not(.search-live)');
    var status = overlay.querySelector('[data-predictive-status]');
    var limit = parseInt(overlay.dataset.predictiveLimit || '5', 10) || 5;
    var labels = {};
    try { labels = JSON.parse(overlay.dataset.predictiveLabels || '{}'); } catch (e) { labels = {}; }
    var base = ((window.HOM && window.HOM.routes && window.HOM.routes.search) || '/search') + '/suggest';
    var timer = null, ctrl = null, last = '';
    function show(html) {
      live.innerHTML = html;
      var res = live.querySelector('[data-predictive-results]');
      var count = res ? parseInt(res.getAttribute('data-count') || '0', 10) : 0;
      if (res) {
        Object.keys(labels).forEach(function (k) {
          var h = res.querySelector('[data-group="' + k + '"] > h6');
          if (h && labels[k]) h.textContent = labels[k];
        });
      }
      live.hidden = !res;
      if (stat) stat.hidden = count > 0;                 /* a miss keeps the suggestion columns under the line */
      input.setAttribute('aria-expanded', res ? 'true' : 'false');
      if (status) status.textContent = res ? (res.getAttribute('data-status') || '') : '';
    }
    function reset() {
      if (ctrl) ctrl.abort();
      clearTimeout(timer);
      live.innerHTML = '';
      live.hidden = true;
      if (stat) stat.hidden = false;
      input.setAttribute('aria-expanded', 'false');
      if (status) status.textContent = '';
      last = '';
    }
    function run() {
      var q = input.value.trim();
      if (q.length < 2) { reset(); return; }
      if (q === last) return;
      last = q;
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = base + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page,article&resources[limit]=' + limit + '&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,vendor,variants.title,tag&section_id=predictive-search';
      fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'text/html' } })
        .then(function (r) { if (!r.ok) { if (last === q) last = ''; return ''; } return r.text(); })
        .then(function (html) { if (input.value.trim() === q) show(html); })
        .catch(function (err) { if (!(err && err.name === 'AbortError') && last === q) last = ''; });   /* a throttled or failed try can be retried */
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 220); });
    input.addEventListener('search', function () { if (!input.value) reset(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && input.value) { input.value = ''; reset(); e.stopPropagation(); }
    });
  }
  function boot(scope) {
    var o = (scope || document).querySelector('.search-overlay');
    if (o) init(o);
  }
  boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
